<div class="container">
    <form [formGroup]="formRastreo" novalidate autocomplete="off">
        <div class="border-top my-3" *ngIf="!visibleUrl"></div>
        <div class="container-rastreo" *ngIf="!visibleUrl">
            <div class="form-group row numero-guia">
                <div class="col-sm-4">
                    <input placeholder="Digite el número de la guia" inputId="numeroGuia" formControlName="numeroGuia"
                        class="form-control" [ngClass]="{ error: numeroGuia.dirty && numeroGuia.errors }" />
                    <div *ngIf="numeroGuia.errors && numeroGuia.dirty">
                        <!-- <p *ngIf="numeroGuia.errors.required">
                        Numero de guia requirido
                    </p> -->
                    </div>
                </div>
                <div class="col-sm-2 btn-buscar  ">
                    <button class="btn triidy-btn-1" [disabled]="formRastreo.invalid"
                        (click)="cargarPedidoByNumeroGuia(numeroGuia.value)">Buscar</button>
                </div>
            </div>
        </div>
        <!-- Barra de estado -->
        <div class="steps">
            <ul class="steps-container">
                <li style="width:25%;" [ngClass]="checkedPrep">
                    <div class="step">
                        <div class="step-image"><span [ngStyle]="checkedPrep && {'background-color': bgcheck}"></span>
                        </div>
                        <div class="step-current">Etapa 1</div>
                        <div class="step-description">Preparacion</div>
                    </div>
                </li>
                <li style="width:25%;" [ngClass]="checkedD">
                    <div class="step">
                        <div class="step-image"><span [ngStyle]="checkedD && {'background-color': bgcheck}"></span>
                        </div>
                        <div class="step-current">Etapa 2</div>
                        <div class="step-description">Despachado</div>
                    </div>
                </li>
                <li style="width:25%;" [ngClass]="checkedR">
                    <div class="step">
                        <div class="step-image"><span [ngStyle]="checkedR && {'background-color': bgcheck}"></span>
                        </div>
                        <div class="step-current">Etapa 3</div>
                        <div class="step-description">En Reparto</div>
                    </div>
                </li>
                <li style="width:25%;" [ngClass]="checkedE">
                    <div class="step">
                        <div class="step-image"><span [ngStyle]="checkedE && {'background-color': bgcheck}"></span>
                        </div>
                        <div class="step-current">Etapa 4</div>
                        <div class="step-description">Entregado</div>
                    </div>
                </li>
            </ul>
            <div class="step-bar" [ngStyle]="{'width': valueCheck, 'background-color': bgcheck}"
                style="transition: width 3s; transition-timing-function: linear; text-align: center;">
                <span *ngIf="checkedP" class="step-pend">Pendiente</span>
                <span *ngIf="checkedA" class="step-anu">Anulado</span>
                <span *ngIf="checkedDev" class="step-pend">Devolucion</span>
                <span *ngIf="checkedProInd" class="step-pend">Proceso de Indemnización</span>
                <span *ngIf="checkedInd" class="step-pend">Indemnizada</span>
                <span *ngIf="checkedNo" class="step-pend">Novedad</span>
            </div>
        </div>

        <div class="border-top my-3"></div>
        <ng-container *ngIf="showSectionPhone">
            <div *ngIf="showValidatorData; else alertInput" class="row_show">
                <ng-container>
                    <div *ngIf="showInput" class="input">
                        <label>Escribe el número de celular correspondiente a la guía. (Intentos: {{ 3 - numberAttempts
                            }})</label>
                        <input type="number" [(ngModel)]="phoneNumber" [ngModelOptions]="{standalone: true}"
                            name="phoneNumber" id="phoneNumber" placeholder="Número de celular">
                    </div>
                    <mat-error *ngIf="showErrorInput">
                        {{ messageInputPhone}}
                    </mat-error>
                </ng-container>
                <button class="btn btn-show" (click)="actionButtonNumber()"
                    *ngIf="showInput === false; else inputBlock">Mostrar
                    datos</button>
                <ng-template #inputBlock>
                    <button class="btn btn-show" (click)="verifyNumber()">Verificar numero</button>
                </ng-template>
            </div>
            <ng-template #alertInput>
                <h4 class="alert">¡¡Numero intentos permitidos por guia incorrectos, espere 2 horas para intentar de
                    nuevo!!
                </h4>
            </ng-template>
        </ng-container>
        <!--DETALLES ENVIO-->
        <div class="box" *ngIf="visible">
            <div class="ribbon ribbon-top-right"><span>Triidy</span></div>
            <div class="container-info" *ngIf="visible" [ngClass]="{ container: visibleUrl }">
                <div class="bord nav">
                    <div class="row">
                        <div class="col-8">
                            <p><span class="triidy-color">Guia:</span> <input class="numer" *ngFor="let gui of guiaArr"
                                    type="text" value="{{gui}}" disabled>
                            </p>
                            <p><span class="blue-color">Estado:</span> {{producto?.estado_transportadora}}</p>
                            <p><span class="blue-color">Fecha Pedido:</span> {{fecha_f | date: 'dd/MM/yyyy'}}</p>
                        </div>
                        <div class="col-4 align-self-center " style="text-align: center;">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <img *ngIf="producto?.url_responsable" [ngClass]="{'envia-inter': enviaInter }"
                                            [src]="producto?.url_responsable" alt="Imagen de perfil">
                                    </div>
                                    <div class="flip-card-back">
                                        <h3>{{producto?.nombre_responsable}}</h3>
                                        <p><i class="fab fa-whatsapp"></i><a target="_blank"
                                                href="{{urlWhatsapp}}/+57{{producto?.telefono_responsable}}"><b>{{producto?.telefono_responsable}}</b></a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="row">
                            <div class="col">
                                <p><span class="blue-color">Nombre Remitente:</span> {{producto?.nombre_remitente}}
                                </p>
                            </div>
                            <div class="col">
                                <p><span class="blue-color">Ciudad Remitente:</span> {{producto?.ciudad_remitente}}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="blue-color">Nombre Destinatario:</span><br>
                                    {{producto?.nombre_destinatario}}
                                </p>
                            </div>
                            <div class="col">
                                <p><span class="blue-color">Ciudad Destinatario:</span><br>
                                    {{producto?.ciudad_destinatario}}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="blue-color">Direccion Destinatario:</span><br>
                                    {{producto?.direccion_destinatario}}
                                </p>
                            </div>
                            <div class="col">
                                <p><span class="blue-color">Telefono Destinatario:</span><br>
                                    {{producto?.telefono_destinatario}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="row r1">
                            <p><span class="blue-color">Metodo de pago:</span> {{producto?.metodo_pago}}</p>
                        </div>
                        <div class="row r2">
                            <p>
                                <span class="blue-color">Detalle de pedido:</span> {{producto?.detalle_pedido}}
                                <button *ngIf="historial" class="butt-hist" (click)="openModal()">Ver historico</button>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="bord mov">
                    <div class="row">
                        <p><span class="triidy-color">Guia:</span><br> <input class="numer" *ngFor="let gui of guiaArr"
                                type="text" value="{{gui}}" disabled>
                        </p>
                    </div>
                    <div class="row">
                        <p><span class="blue-color">Estado:</span> {{producto?.estado_transportadora}}</p>
                    </div>
                    <div class="row">
                        <p><span class="blue-color">Fecha Pedido:</span> {{fecha_f | date: 'dd/MM/yyyy'}}</p>
                    </div>
                    <div class="row" style="text-align: center; display: block;">
                        <img *ngIf="producto?.url_responsable" [ngClass]="{'envia-inter': enviaInter }"
                            [src]="producto?.url_responsable" alt="Imagen de perfil">
                    </div>
                    <div class="row" style="text-align: center; display: block;">
                        <h5>{{producto?.nombre_responsable}}</h5>
                        <p><i *ngIf="producto?.telefono_responsable" class="fab fa-whatsapp"></i><a target="_blank"
                                href="{{urlWhatsapp}}/+57{{producto?.telefono_responsable}}"><b>{{producto?.telefono_responsable}}</b></a>
                        </p>
                    </div>

                    <hr>
                    <div class="row">
                        <p><span class="blue-color">Nombre Remitente:</span> {{producto?.nombre_remitente}}
                        </p>
                    </div>
                    <div class="row">
                        <p><span class="blue-color">Ciudad Remitente:</span> {{producto?.ciudad_remitente}}
                        </p>
                    </div>
                    <div class="row">
                        <p><span class="blue-color">Nombre Destinatario:</span><br> {{producto?.nombre_destinatario}}
                        </p>
                    </div>
                    <div class="row">
                        <p><span class="blue-color">Ciudad Destinatario:</span><br> {{producto?.ciudad_destinatario}}
                        </p>
                    </div>
                    <div class="row">
                        <p><span class="blue-color">Direccion Destinatario:</span><br>
                            {{producto?.direccion_destinatario}}
                        </p>
                    </div>
                    <hr>
                    <div class="row">
                        <p><span class="blue-color">Metodo de pago:</span> {{producto?.metodo_pago}}</p>
                    </div>
                    <div class="row">
                        <p>
                            <span class="blue-color">Detalle de pedido:</span> {{producto?.detalle_pedido}}
                            <button *ngIf="historial" class="butt-hist" (click)="openModal()">Ver historico</button>
                        </p>
                    </div>
                </div>


                <!-- <div *ngIf="fileUrl">
                        <a [href]="fileUrl" download="comprobante.tiff">Descargar
                            comprobante</a>
                    </div>-->
            </div>
        </div>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
        <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>

    <div id="myModalR" class="modal" *ngIf="muestra">
        <span class="close" (click)="closeModal()">&times;</span>
        <div class="row history" *ngIf="historial">
            <ul class="list_historial">
                <li *ngFor="let nov of history; let i = index" [ngClass]="{'complete': (i+1) >= 1}">
                    <span>{{ i + 1 }}</span>
                    <div class="detalle_hist">
                        <p>
                            <b>{{ nov.Fecha }}</b>
                        </p>
                        <p>{{ nov.Movimiento }}</p>
                    </div>
                    <div class="hora_hist">
                        <p>
                            <b>{{ nov.Hora }}</b>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>


    <!-- <button #openModalButton id="openModalButton" [hidden]="true" data-toggle="modal" data-target="#modalNoData"></button>
    <div #modalNoData id="modalNoData" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center triidy-color" id="exampleModalLongTitle">Número de guía no encontrado
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="list-group">
                        <li class="list-group-item"><i class="fas fa-exclamation-triangle m-1"></i>1. Confirma el número de Guía
                        </li>
                        <li class="list-group-item"><i class="fas fa-exclamation-triangle m-1"></i>2. Vuelve a digitar el número de guía
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div> -->
</div>